import { useAppData } from "src/context/useAppData"
import { localStorageFactory } from "src/utils/storageUtil"

/** Convenience hook to get the current user.
 *
 * N.B: Can _only_ be used within authenticated routes. Contexts outside of such
 * a route must fetch the potentially undefined user from AppData.
 */
export function useGetUser() {
  const { user } = useAppData()
  const fakeSalesAdminStorage = localStorageFactory<{ isSalesAdmin: boolean }>({
    key: "minut.paradise.user.faking_sales_admin",
  })

  if (!user) {
    throw Error(
      "Hook is being used in a context where user is not available; fetch the user from AppData instead"
    )
  }

  // Very ugly hack to quickly switch between superadmin and sales admin to troubleshoot
  // what sales_admins have access to without signing in and out.
  if (
    fakeSalesAdminStorage.get()?.isSalesAdmin === true &&
    user.roles.includes("superadmin")
  ) {
    // Replace it with sales_admin
    user.roles = [
      ...user.roles.filter((role) => role !== "superadmin"),
      "sales_admin",
      "can_be_superadmin", // This is needed to show the "Become superadmin" button in the profile menu
    ]
  }

  return user
}
